exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".aflac-quote-card{padding:15px;width:100%;border:2px solid #cdcdcd;margin:0 !important}@media(min-width: 576px){.aflac-quote-card{height:230px}}.aflac-quote-card img{height:2.5rem}.aflac-quote-card p{font-size:.6rem !important;line-height:.75rem}.aflac-quote-card h3{margin-bottom:0}.aflac-quote-card button .MuiButton-label{font-weight:600;font-size:.8rem}@media(min-width: 768px){.aflac-quote-card button .MuiButton-label{font-size:inherit}}.dots{font-size:1.8rem;font-weight:bold}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/Quoters/Supplemental/Helpers/QuoteCard.scss
// module id = 7846
// module chunks = 13